// store/toastNotifications.js
export default {
    namespaced: true,
    
    state: () => ({
      queue: [],
    }),
    
    mutations: {
      PUSH(state, toast) { 
        console.log('Adding toast to queue:', toast);
        state.queue.push(toast); 
      },
      SHIFT(state) { 
        console.log('Removing toast from queue');
        state.queue.shift(); 
      },
      CLEAR(state) { 
        console.log('Clearing toast queue');
        state.queue = []; 
      },
    },
    
    actions: {
      notify({ commit }, payload) {        
        // Ensure payload has required properties
        const toast = {
          severity: payload.severity || 'info',
          summary: payload.summary || 'Notification',
          detail: payload.detail || '',
          life: payload.life || 3000
        };
        
        commit('PUSH', toast);
      },
      
      pop({ commit }) {
        commit('SHIFT');
      },
      
      clearAll({ commit }) {
        commit('CLEAR');
      }
    },
  };